import React, { useEffect, useState } from "react";
import { Link } from "gatsby";
import { useStaticQuery, graphql } from "gatsby";

import slugify from "slugify";

export default function MainMenu(props) {
  const [path, setPath] = useState("");

  useEffect(() => {
    setPath(window.location.href);
  }, []);

  const { allFeatCategories } = useStaticQuery(
    graphql`
      query {
        allFeatCategories {
          nodes {
            name
            seoMetaData{
              slug
            }
          }
        }
      }
    `
  );
  return (
    <nav aria-label="navigation" style={{ margin: "0 auto" }} className="main-nav">
      <ul className="menu sf-arrows">
        <li className={path.indexOf("shop") > -1 ? "active" : ""}></li>

        <li className={path.indexOf("pages") > -1 ? "active" : ""}></li>
        {allFeatCategories.nodes.map((category, index) => {
          return (
            <li
              className={path.indexOf("categorys") > -1 ? "active" : ""}
              key={index}
            >
              <Link to={`/collections/${category?.seoMetaData?.slug||slugify(category.name.toLowerCase())}/`}>
                {category.name}
              </Link>
            </li>
          );
        })}
        {/* <li className={path.indexOf("pages") > -1 ? "active" : ""}>
          <Link to={`/contact`}>Contact</Link>
        </li>
        <li className={path.indexOf("pages") > -1 ? "active" : ""}>
          <Link to={`/productrequest`}>Request a product</Link>
        </li> */}
        <li className={path.indexOf("blog/") > -1 ? "active" : ""}>
          {/* className="sf-with-ul" */}
          {/* <Link to={ `/faqs` } >FAQS</Link> */}
        </li>
      </ul>
    </nav>
  );
}
